import React, { useState, useEffect } from 'react';
import { workflowsApi } from '../services/api';

/** Modale de lancement d'une exécution depuis un modèle. */
export default function WorkflowLaunchModal({ presetTemplateId, onClose, onLaunched }) {
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState(presetTemplateId || '');
  const [name, setName] = useState('');
  const [societe, setSociete] = useState('');
  const [entityType, setEntityType] = useState('');
  const [entityId, setEntityId] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    workflowsApi.listTemplates().then(({ data }) => {
      setTemplates(data.templates || []);
      if (presetTemplateId) {
        const t = (data.templates || []).find((x) => x.id === presetTemplateId);
        if (t && !name) setName(t.name);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPickTemplate = (id) => {
    setTemplateId(id);
    const t = templates.find((x) => String(x.id) === String(id));
    if (t && !name) setName(t.name);
    if (t && t.societe && !societe) setSociete(t.societe);
  };

  const submit = async () => {
    if (!templateId) { alert('Choisissez un modèle.'); return; }
    if (!name.trim()) { alert('Donnez un nom à l\'exécution.'); return; }
    setSaving(true);
    try {
      const { data } = await workflowsApi.createExecution({
        template_id: Number(templateId), name: name.trim(),
        societe: societe || undefined, entity_type: entityType || undefined, entity_id: entityId || undefined,
      });
      onLaunched(data.execution);
    } catch (e) {
      alert(e?.response?.data?.error || 'Échec du lancement.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Lancer une exécution</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <div className="wf-field">
            <label>Modèle *</label>
            <select className="page-select" value={templateId} onChange={(e) => onPickTemplate(e.target.value)}>
              <option value="">— Choisir un modèle —</option>
              {templates.map((t) => <option key={t.id} value={t.id}>{t.name}{t.category ? ` (${t.category})` : ''}</option>)}
            </select>
          </div>
          <div className="wf-field">
            <label>Nom de l'exécution *</label>
            <input value={name} placeholder="ex. VO Dupont — 18/06" onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="wf-field">
            <label>Société (optionnel)</label>
            <input value={societe} placeholder="ex. Garage Martin" onChange={(e) => setSociete(e.target.value)} />
          </div>
          <div className="wf-meta-row">
            <div className="wf-field">
              <label>Type d'entité (optionnel)</label>
              <input value={entityType} placeholder="ex. client, dossier" onChange={(e) => setEntityType(e.target.value)} />
            </div>
            <div className="wf-field">
              <label>ID d'entité (optionnel)</label>
              <input value={entityId} placeholder="ex. 4321" onChange={(e) => setEntityId(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn-primary" onClick={submit} disabled={saving}>{saving ? 'Lancement…' : 'Lancer'}</button>
        </div>
      </div>
    </div>
  );
}
